import type { Anomaly } from '@gozoki/api-types';
import { useQuery } from '@tanstack/react-query';

export const useAnomalies = (storeId: string) => {
    return useQuery<Anomaly[], Error>({
        queryKey: ['anomalies', storeId],
        queryFn: () => {
            if (Number.isNaN(Number(storeId))) return [];
            return [];
        },
        initialData: [] as Anomaly[],
    });
};
